import { createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";

const initialState = {
  token: localStorage.getItem("token") || null,
  username: localStorage.getItem("username") || null,
  image: localStorage.getItem("image") || null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.token = action.payload.token;
      state.username = action.payload.username;
      localStorage.setItem("token", action.payload.token); // Save token to localStorage
      localStorage.setItem("username", action.payload.username); // Save username to localStorage
      localStorage.setItem("image", action.payload.image);
    },
    clearCredentials: (state) => {
      state.token = null;
      state.username = null;
      localStorage.removeItem("token"); // Remove token from localStorage
      localStorage.removeItem("username"); // Remove username from localStorage
      localStorage.removeItem("image");
      toast.success("Login Session Expired", {
        style: {
          border: "1px solid #021F7E",
          padding: "16px",
          color: "#0573E3",
        },
        iconTheme: {
          primary: "#021F7E",
          secondary: "#0573E3",
        },
      });
    },
    updateImage: (state, action) => {
      state.image = action.payload; // Update the image field in state
      localStorage.setItem("image", action.payload); // Save the new image to localStorage
    },
  },
});

export const { setCredentials, clearCredentials, updateImage } =
  authSlice.actions;
export default authSlice.reducer;
